export default __webpack_public_path__ + "static/media/movieadda.529bc540.png";